import { mmFetchWithResponse } from './mmFetchWithResponse';

const marketplaceApi = {
    editCuratedListInfo: async (id, sendParams) => {
        const url = `api/marketplace/v1/curatedLists/info/${id}`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
        return response;
    },
};

export { marketplaceApi };
